import apiRequest from './client';

// RÈG 2 — Validation Konbinezon (menu Securite). Portée company / group / bank ;
// au plus une règle par cible côté backend (KonbinezonValidationRule).

export const listKonbinezonValidationRules = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  const qs = params.toString();
  return apiRequest(`/konbinezon-validation-rules/${qs ? `?${qs}` : ''}`);
};

export const createKonbinezonValidationRule = (data) =>
  apiRequest('/konbinezon-validation-rules/', { method: 'POST', body: data });

export const updateKonbinezonValidationRule = (id, data) =>
  apiRequest(`/konbinezon-validation-rules/${id}/`, { method: 'PATCH', body: data });

export const deleteKonbinezonValidationRule = (id) =>
  apiRequest(`/konbinezon-validation-rules/${id}/`, { method: 'DELETE' });
